<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="dataLoaded">{{data.title}}</h4>
</div>

<div class="modal-body" *ngIf="dataLoaded">
    <validation-results [validationResults]="validationModel" *ngIf="validationModel.validationResults.length > 0"></validation-results>
    <form [formGroup]="addDeInsuranceForm">
        <fieldset>
            <div class="row">
                <div class="col-sm-4 col-md-2 mvd_form-group">
                    <label>Effective Date</label>
                    <p-calendar id="effectiveDate" [showIcon]="true" formControlName="effectiveDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"></p-calendar>
                    <control-validation-messages control="effectiveDate"></control-validation-messages>
                </div>
                <div class="col-sm-4 col-md-2 mvd_form-group">
                    <label>End Date</label>
                    <p-calendar id="endDate" [showIcon]="true" formControlName="endDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"></p-calendar>
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Certificate Received Date</label>
                    <div class="mvd_form-control">{{data.vehicleOwnershipDeInsurance.receivedDate | shortDate}}</div>
                </div>
                <div class="col-sm-4 col-md-5 mvd_form-group">
                    <label>De-insurance Reason</label>
                    <select class="mvd_form-control" formControlName="vehicleOwnershipDeInsuranceReasonTypeId">
                        <option value="0" disabled="disabled">- Select -</option>
                        <option *ngFor="let reasonType of reasonTypes" value="{{reasonType.id}}">{{reasonType.displayValue}}</option>
                    </select>
                    <control-validation-messages control="vehicleOwnershipDeInsuranceReasonTypeId"></control-validation-messages>
                </div>
            </div>
        </fieldset>

        <div class="document-retrieve--container">
            <document-retrieve-upload [searchDocumentDataCollection]="searchDocumentDataCollection" [minimalComponent]="true"></document-retrieve-upload>
        </div>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <mvm-spinner-btn [btnText]="data.buttonText" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>

